/**
 * Formats a date/time value to local timezone with consistent formatting
 * @param date - Date string, Date object, or null/undefined
 * @returns Formatted date string in local timezone (24h format with seconds)
 */
export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return "Unknown";

  try {
    // Convert to string if it's a Date object
    const dateStr = typeof date === "string" ? date : date.toISOString();

    // Ensure UTC timezone marker for proper parsing
    const utcDateStr = dateStr.endsWith("Z") ? dateStr : dateStr + "Z";

    // Format in local timezone
    return new Date(utcDateStr).toLocaleString([], {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid date";
  }
}
